export default {
  DriverDocument: "DriverDocument",
  AddDriverDocument: "AddDriverDocument",
  editDriverDocument: "EditDriverDocument",
};
